import { useEffect, useState } from "react";
import badgesBg from "assets/images/others/host-side-images/badgesBg.png";
import { siteRoutes } from "utils/helpers/enums/routes";
import MinorBreadcrumb, {
  MinorBreadcrumbLink,
} from "components/breadcrumbs/MinorBreadcrumb";
import TicketPopup from "components/popups/pass-popup";
import { getFilePathWithBackendUrl } from "utils/helpers/common/http-methods";
import { EventDTO } from "utils/helpers/models/shared/event.dto";
import useUtils from "hooks/useUtils";
import useMinor from "../useHooks";
import WorkshopSessionPopup from "components/popups/workshop-session";
import ExperienceDetailHeader from "components/experience-detail-header";
import PassModal from "./component/PassModal";

const EventPass: React.FC = () => {
  const [isPassPopupOpen, setIsPassPopupOpen] = useState(false);
  const [selectedSubscriber, setSelectedSubscriber] = useState<any>(null);
  const { getQueryParams } = useUtils();
  const [event, setEvent] = useState<EventDTO>(new EventDTO());
  const params = getQueryParams();

  const [workshopSessionModal, setWorkshopSessionModal] = useState(false);
  const { getEventById } = useMinor();

  const getEventDataByID = async () => {
    if (params?.id) {
      await getEventById(params?.id, setEvent);
    }
  };

  useEffect(() => {
    getEventDataByID();
  }, []);

  // hide button on the base of startTime
  const firstSession = event.workshopSessions?.[0];
  const firstSessionDateTime = firstSession
    ? new Date(
        `${firstSession.startDateWithMonthAndYear} ${firstSession.startTime}`
      )
    : null;
  const hasStarted =
    firstSessionDateTime ? new Date() >= firstSessionDateTime : false;
  const visibleSessions = event.workshopSessions.slice(0, 3);
  const hasMoreSessions = event.workshopSessions.length > 3;

  const breadcrumbLinks: MinorBreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.minorHome },

    { title: "Ticket Pass", path: siteRoutes.minorTicket },
  ];

  return (
    <div>
      <ExperienceDetailHeader
        event={event}
        breadcrumb={<MinorBreadcrumb links={breadcrumbLinks} />}
        // onHostClick={goToHostDetail}
        onSeeMoreSessions={() => setWorkshopSessionModal(true)}
        visibleSessions={visibleSessions}
        hasMoreSessions={hasMoreSessions}
        gradientClass="minor-bg-gradient"
      />
      <div className="container py-6">
        <div>
          <h2 className="text-2xl font-medium text-blackie my-6">
            Ticket Pass
          </h2>
          <div className="flex flex-wrap items-center gap-4 py-5">
            {event.eventSubscriptions.map((item: any, index: number) => (
              <div
                key={index + 1}
                className="flex flex-col items-center justify-center p-4 rounded-lg w-[235px] h-[260px] cursor-pointer"
                style={{
                  backgroundImage: `url(${badgesBg})`,
                  backgroundSize: "cover",
                }}
              >
                <div className="hover:scale-110 transition-transform duration-300">
                  <img
                    className="w-[98px] h-[98px] rounded-full"
                    src={getFilePathWithBackendUrl(
                      item?.profilePicUrl?.fileDownloadUri
                    )}
                    alt={item.title}
                  />
                </div>
                <span className="text-base font-semibold mt-2 text-blackie">
                  {item.title}
                </span>
                <span
                  onClick={() => {
                    setSelectedSubscriber(item);
                    setIsPassPopupOpen(true);
                  }}
                  className=" text-sm text-yellowText cursor-pointer"
                >
                  View Pass
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      {isPassPopupOpen && (
        <PassModal
          isOpen={isPassPopupOpen}
          onClose={() => {
            setIsPassPopupOpen(false);
            setSelectedSubscriber(null);
          }}
          eventData={event}
          selectedSubscriber={selectedSubscriber}
        />
      )}

      {workshopSessionModal && (
        <WorkshopSessionPopup
          isOpen={workshopSessionModal}
          onClose={() => setWorkshopSessionModal(false)}
          sessions={event.workshopSessions}
        />
      )}
    </div>
  );
};

export default EventPass;
